import { defineTenant } from './theme/config'
export default defineTenant({
  brand: {
    name: 'Maybank',
    logo: {
      light:
        'https://cdn.magicpatterns.com/uploads/8CEfnMi98Exy22uVryD7AF/Screenshot_2026-05-05_at_17-59-41_.png',
      dark: 'https://cdn.magicpatterns.com/uploads/8CEfnMi98Exy22uVryD7AF/Screenshot_2026-05-05_at_17-59-41_.png',
    },
    favicon:
      'https://cdn.magicpatterns.com/uploads/8CEfnMi98Exy22uVryD7AF/Screenshot_2026-05-05_at_17-59-41_.png',
  },
  locale: {
    default: 'en-US',
    supported: ['en-US'],
    timezone: 'Asia/Kuala_Lumpur',
  },
  currency: {
    code: 'MYR',
  },
})
